<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="none"
  >
    <g id="style=linear">
      <g id="warning-circle">
        <path
          id="vector"
          d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
          stroke="#F1416C"
          stroke-width="1.5"
        />
        <path
          id="vector_2"
          d="M12 7V14.1047"
          stroke="#F1416C"
          stroke-width="1.5"
          stroke-linecap="round"
        />
        <path
          id="ellipse"
          d="M12 17H12.01"
          stroke="#F1416C"
          stroke-width="2"
          stroke-linecap="round"
        />
      </g>
    </g>
  </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
  name: "CircleInfoIcon"
});
</script>
